export enum EnrollmentStatusEnum {
  InProgress = 1,
  Confirmed = 2,
  Rejected = 3,
}
